import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { useEnquire } from "@/components/ContactModal";

const Footer = () => {
  const { t } = useLang();
  const { setOpen } = useEnquire();

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 py-20">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <div className="grid gap-16 md:grid-cols-12">
          <div className="md:col-span-6">
            <img src="/images/logo.png" alt="Jano Automobili" data-testid="footer-logo" className="w-[17.5rem] sm:w-[22.5rem]" />
            <p className="mt-10 font-heritage text-3xl italic text-white/80">{t.footer.tagline}</p>
            <button
              data-testid="footer-enquire-button"
              onClick={() => setOpen(true)}
              className="mt-10 rounded-full border border-white/25 px-8 py-3 font-tech text-sm uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:border-[#4A7BA6] hover:bg-[#4A7BA6]"
            >
              {t.nav.enquire}
            </button>
          </div>
          <div className="md:col-span-3">
            <p className="font-tech text-xs uppercase tracking-[0.35em] text-white/40">Menu</p>
            <div className="mt-6 flex flex-col gap-4">
              <Link to="/" data-testid="footer-home-link" className="text-white/70 transition-colors hover:text-[#4A7BA6]">{t.nav.home}</Link>
              <Link to="/biography" data-testid="footer-biography-link" className="text-white/70 transition-colors hover:text-[#4A7BA6]">{t.nav.biography}</Link>
              <Link to="/otto-cilindri-manuale" data-testid="footer-vj8c-link" className="text-white/70 transition-colors hover:text-[#4A7BA6]">{t.nav.vj8c}</Link>
              <Link to="/bi-venti" data-testid="footer-biventi-link" className="text-white/70 transition-colors hover:text-[#4A7BA6]">{t.nav.biventi}</Link>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="font-tech text-xs uppercase tracking-[0.35em] text-white/40">Atelier</p>
            <p className="mt-6 text-white/70">Torino, Italia</p>
            <p className="mt-2 text-white/40">www.janoautomobili.com</p>
          </div>
        </div>
        <p className="mt-14 text-sm text-white/30" data-testid="footer-rights">{t.footer.rights}</p>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/30" data-testid="footer-disclaimer">{t.footer.disclaimer}</p>
        <div aria-hidden="true" className="pointer-events-none mt-10 select-none pb-12 text-center font-tech text-[16vw] font-bold uppercase leading-[0.9] text-white/[0.05]">
          Jano
        </div>
      </div>
    </footer>
  );
};

export default Footer;
